module.exports = __webpack_public_path__ + "media/images/sp/specials/common/special_c_11-8ddf62cdba7533db9695ef7e2dbd7d5d.jpg";